import React from 'react';
import { AlertCircle, CheckCircle, UploadCloud } from 'lucide-react';
import { Badge } from '../../ui/badge';
import { checkFileStatus } from '../../../utils/course-builder/editModeFileHandler';

const FileStatusIndicator = ({ fileData, onReupload }) => {
  const status = checkFileStatus(fileData);

  if (!status.hasFile) {
    return (
      <div className="flex items-center text-sm text-muted-foreground">
        <UploadCloud className="h-4 w-4" />
        <span>No file uploaded</span>
      </div>
    );
  }

  if (status.needsReupload) {
    return (
      <div className="flex items-center">
        <AlertCircle className="h-4 w-4 text-orange-500" />
        <Badge variant="outline" className="text-orange-600 border-orange-300">
          Needs Re-upload
        </Badge>
        {onReupload && (
          <button
            onClick={onReupload}
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Re-upload
          </button>
        )}
      </div>
    );
  }

  if (status.isExisting) {
    return (
      <div className="flex items-center">
        <CheckCircle className="h-4 w-4 text-green-500" />
        <Badge variant="outline" className="text-green-600 border-green-300">
          Existing File
        </Badge>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <CheckCircle className="h-4 w-4 text-green-500" />
      <Badge variant="outline" className="text-green-600 border-green-300">
        Uploaded
      </Badge>
    </div>
  );
};

export default FileStatusIndicator; 